import Api from 'api/api';
import { queryKeys } from 'api/queryKeys';

export const survey = {
  queryKey: queryKeys.survey,
  queryFn: Api.getRegistrySurvey,
};
